import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "filters mt-30 sm-mt-0 sm-mb-5 w-100 mb-20 ml-10 sm-ml-0 d-flex gap-20 flex-md-row flex-column" }
const _hoisted_3 = { class: "bordered-card bordered-card_secondary gap-20 p-2 pdt-15 pdb-35 ml-10 sm-ml-0 overflow-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "bg-light-green w-100 pdl-20 pdt-25 pdb-25 rounded sm-fs-base" }, " Plan Forms & Documents", -1)
const _hoisted_5 = {
  key: 1,
  class: "w-100 text-center fs-sm sm-fs-xxs"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "fw-bold sm-fs-sm" }
const _hoisted_8 = { class: "toggle-btn" }
const _hoisted_9 = {
  key: 0,
  class: "fs-xl lh-1"
}
const _hoisted_10 = {
  key: 1,
  class: "fs-xl lh-1"
}
const _hoisted_11 = {
  key: 0,
  class: "secondary-group d-flex flex-md-row flex-column w-100 pdr-0 pdl-20"
}
const _hoisted_12 = { class: "secondary_group_item d-flex flex-column gap-20" }
const _hoisted_13 = { class: "fw-semibold sm-fs-sm" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-pdf d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_16 = { class: "sm-fs-xs" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-select-arrow fs-xxs text-primary" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "divider divider_vertical h-100 m-0"
}
const _hoisted_20 = {
  key: 0,
  class: "divider m-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        placeholder: "Search by Document Name",
        max: 50,
        modelValue: $setup.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchTerm) = $event)),
        customClass: "search sm-mb-10"
      }, null, 8, ["modelValue"]),
      ($setup.isParticipant)
        ? (_openBlock(), _createBlock(_component_SelectComponent, {
            key: 0,
            selectedOption: $setup.fund,
            "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => (($setup.fund) = $event)),
            options: $setup.funds,
            customClass: "w-50 w-sm-100",
            readonly: $setup.fundProp
          }, null, 8, ["selectedOption", "options", "readonly"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      ($setup.loading)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
        : (!Object.values($setup.filteredValues)?.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "No resources have been found."))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.filteredValues, (resourceGroup, mainKey, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: mainKey }, [
                _createElementVNode("div", {
                  class: "primary-group primary-group_page d-flex justify-content-between align-items-center w-100 plan-modal pdl-20",
                  onClick: ($event: any) => ($setup.toggleGroup(mainKey))
                }, [
                  _createElementVNode("h5", _hoisted_7, _toDisplayString(mainKey) + " " + _toDisplayString($setup.isLocal ? 'Documents' : ''), 1),
                  _createElementVNode("button", _hoisted_8, [
                    (!$setup.showGroup[mainKey])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "+"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                  ])
                ], 8, _hoisted_6),
                _createVNode(_Transition, { name: "slide-fade" }, {
                  default: _withCtx(() => [
                    ($setup.showGroup[mainKey])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceGroup, (documents, secondaryKey, secondaryIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: secondaryKey }, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("h5", _hoisted_13, _toDisplayString(secondaryKey), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getVisibleDocuments(documents, mainKey, secondaryKey), (doc, docIndex) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: docIndex,
                                    href: doc.file_url,
                                    target: "_blank",
                                    class: _normalizeClass([{'fade-in': $setup.isExpanded(mainKey, secondaryKey) && docIndex >= 3, 'fade-out': !$setup.isExpanded(mainKey, secondaryKey) && docIndex > 3}, "document-item gap-10"])
                                  }, [
                                    _hoisted_15,
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(doc.title), 1)
                                  ], 10, _hoisted_14))
                                }), 128)),
                                (documents.length > 3)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => ($setup.toggleDocs(mainKey, secondaryKey)),
                                      class: _normalizeClass(["btn btn-link p-0 justify-content-start", {'bounce-up': $setup.isExpanded(mainKey, secondaryKey), 'bounce-down': !$setup.isExpanded(mainKey, secondaryKey)}])
                                    }, [
                                      _hoisted_18,
                                      _createTextVNode(" " + _toDisplayString($setup.isExpanded(mainKey, secondaryKey) ? 'View Less' : 'View More'), 1)
                                    ], 10, _hoisted_17))
                                  : _createCommentVNode("", true)
                              ]),
                              (secondaryIndex < Object.entries(resourceGroup).length - 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                (index < Object.entries($setup.resources).length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
    ])
  ]))
}